import { useState } from "react";
import { toast } from "sonner";
import { Printer, Download, Eye, ExternalLink } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

export default function PdfPreview({ path, filename, label = "Preview & print", testid, className = "" }) {
  const [url, setUrl] = useState(null);
  const [busy, setBusy] = useState(false);
  const open = async () => {
    setBusy(true);
    try { const r = await api.get(path, { responseType: "blob" }); setUrl(URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }))); }
    catch (e) { toast.error(e?.response?.status === 403 ? "You are not allowed to print this document" : errMsg(e)); }
    finally { setBusy(false); }
  };
  const close = () => { URL.revokeObjectURL(url); setUrl(null); };
  const print = () => { document.getElementById("pdf-preview-frame")?.contentWindow?.print(); };
  return (
    <>
      <button onClick={open} disabled={busy} data-testid={testid}
        className={`inline-flex items-center gap-2 border border-[#3B220C] px-4 py-2 text-sm hover:bg-[#3B220C] hover:text-white transition-colors disabled:opacity-50 ${className}`}><Eye size={14} />{busy ? "Loading..." : label}</button>
      <Dialog open={!!url} onOpenChange={(v) => !v && close()}>
        <DialogContent className="rounded-none max-w-3xl w-[95vw] h-[90vh] flex flex-col gap-3" data-testid="pdf-preview-dialog">
          <DialogTitle className="font-serif text-2xl font-normal">Preview</DialogTitle>
          {url && <iframe id="pdf-preview-frame" title="PDF preview" src={url} className="flex-1 w-full border border-[#E6DFD5] bg-white" data-testid="pdf-preview-frame" />}
          <div className="flex flex-wrap gap-2 justify-end">
            <a href={url || "#"} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 border border-[#3B220C] px-4 py-2 text-sm" data-testid="pdf-preview-open-tab"><ExternalLink size={14} />Open in new tab</a>
            <a href={url || "#"} download={filename} className="inline-flex items-center gap-2 border border-[#3B220C] px-4 py-2 text-sm" data-testid="pdf-preview-download"><Download size={14} />Download</a>
            <button onClick={print} className="inline-flex items-center gap-2 bg-[#3B220C] text-white px-4 py-2 text-sm" data-testid="pdf-preview-print"><Printer size={14} />Print</button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
